import { createSelector } from "reselect"
import { get } from "lodash"
import { getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"

const getPeriod = (state, props) => get(props, "period")
const getStartDate = (state, props) => get(props, "startDate")
const getEndDate = (state, props) => get(props, "endDate")
const getLatestDate = (state, props) => get(props, "latestDate")

export const getDatesAdjusted = createSelector(
  [getPeriod, getStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)
